import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    document.querySelector("body").addEventListener("stepbar:update", this.updateState.bind(this));
  }

  updateState(event) {
    const step = document.getElementById(`${event.detail.step}-step`);
    if (step.tagName === "DIV") {
      if (event.detail.action == 'active') {
        step.classList.remove("pending-step");
        step.classList.add("active-step");
        step.nextElementSibling.classList.remove("text-[#666666]");
        step.nextElementSibling.classList.add("link");
        step.children[0].classList.remove("text-[#B9B9B9]");
        step.children[0].classList.add("link");
      } else {
        step.classList.remove("active-step");
        step.classList.add("pending-step");
        step.nextElementSibling.classList.remove("link");
        step.nextElementSibling.classList.add("text-[#666666]");
        step.children[0].classList.remove("link");
        step.children[0].classList.add("text-[#B9B9B9]");
      }
    } else {
      if (event.detail.action == 'active') {
        step.classList.remove("text-[#666666]");
        step.classList.add("link");
      } else {
        step.classList.remove("link");
        step.classList.add("text-[#666666]");
      }
    }
  }
}